import * as actionTypes from "../../constants/actionTypes";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as resultCodes from "../../constants/resultCodes";
import * as virtualKeyboardActions from "../../actions/virtualKeyboardActions";
import * as messageHelper from "../../helpers/messageHelper";
import * as modelHelper from "../../helpers/modelHelper";
import * as responseHelper from "../../helpers/responseHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.GET_LOGGED_USER:
        case handlers.GET_LOGGED_DATABASE_USER:
            if (!responseHelper.isGetLoggedUserFormatValid(response)) {
                return [
                    messageHelper.getInvalidFormatMessage(response),
                    {
                        type: actionTypes.SOFTWARE_INITIALIZED
                    }
                ];
            }

            if (response.data.logged === true) {
                return [
                    {
                        type: actionTypes.LOG_IN_SUCCESS,
                        payload: {
                            loggedUser: response.data.user,
                            settingsMenu: modelHelper.mapSettingsMenuToObjects(response.data.user.optionsMenu)
                        }
                    }
                ];
            }

            const toReturn = [
                {
                    type: actionTypes.LOG_IN_FAILURE
                },
                {
                    type: actionTypes.SOFTWARE_INITIALIZED
                }
            ];

            if (method === handlers.GET_LOGGED_DATABASE_USER) {
                toReturn.push(messageHelper.getErrorMessageAction("flashMessage.autologinFailed"));
            }

            return toReturn;
        case handlers.LOG_IN:
            if (response.result === resultCodes.RESULT_LOGIN_FAILED) {
                if (window.jQuery("#keyboard-password").length) {
                    window.jQuery("#keyboard-password").focus();
                    window.jQuery("#keyboard-password").select();
                }

                return [
                    {
                        type: actionTypes.LOG_IN_FAILURE
                    },
                    messageHelper.getWarningMessageAction("login.messages.incorrectUsername")
                ];
            }

            if (!responseHelper.isLoggedUserFormatValid(response)) {
                return [
                    messageHelper.getInvalidFormatMessage(response),
                    {
                        type: actionTypes.SOFTWARE_INITIALIZED
                    }
                ];
            }

            if (response.result === resultCodes.RESULT_OK) {
                return [
                    {
                        type: actionTypes.LOG_IN_SUCCESS,
                        payload: {
                            loggedUser: response.data.user,
                            settingsMenu: modelHelper.mapSettingsMenuToObjects(response.data.user.optionsMenu)
                        }
                    },
                    {
                        type: actionTypes.SOFTWARE_NOT_INITIALIZED
                    },
                    virtualKeyboardActions.setKeyBoardState(false)
                ];
            }

            return [
                messageHelper.getFlashMessage(response),
                {
                    type: actionTypes.LOG_IN_FAILURE
                }
            ];
        case handlers.LOG_OUT:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.LOG_OUT_SUCCESS
                }
            ];
        case handlers.VALIDATE_USER_PASSWORD:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (response.data === true) {
                return [
                    {
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_LOG_OUT
                        },
                        method: handlers.LOG_OUT_AND_CHANGE_USER,
                        tabId: 0
                    },
                    virtualKeyboardActions.setKeyBoardState(false)
                ];
            }

            if (window.jQuery("#keyboard-password").length) {
                window.jQuery("#keyboard-password").focus();
                window.jQuery("#keyboard-password").select();
            }

            return [messageHelper.getWarningMessageAction("login.messages.incorrectUsername")];
        case handlers.VALIDATE_USER_PASSWORD_AUTHENTICATION:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (response.data === true) {
                let validateRequest = state.server.requests.find((request) => request.id === response.sequence);

                if (validateRequest.next === null) {
                    return [
                        {
                            type: actionTypes.NAVIGATION_CLOSE_ALL_MODALS
                        },
                        {
                            type: actionTypes.LOG_IN_SET_PASSWORD,
                            payload: {
                                password: ""
                            }
                        },
                        virtualKeyboardActions.setKeyBoardState(false)
                    ];
                }

                return [
                    {
                        type: actionTypes.NAVIGATION_CLOSE_ALL_MODALS
                    },
                    {
                        type: actionTypes.LOG_IN_SET_PASSWORD,
                        payload: {
                            password: ""
                        }
                    },
                    virtualKeyboardActions.setKeyBoardState(false),
                    validateRequest.next
                ];
            }

            return [messageHelper.getWarningMessageAction("login.messages.incorrectUsername")];
        case handlers.LOG_OUT_AND_CHANGE_USER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            var sha256 = require("sha256");

            return [
                {
                    type: actionTypes.NAVIGATION_CLOSE_ALL_MODALS
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_LOG_IN,
                        params: {
                            login: state.login.login,
                            password: sha256(state.login.password).toUpperCase()
                        }
                    },
                    method: handlers.LOG_IN_AND_CHANGE_USER,
                    tabId: 0
                }
            ];
        case handlers.LOG_IN_AND_CHANGE_USER:
            if (!state.login.loggedIn) {
                return [];
            }

            if (
                response.result === resultCodes.RESULT_LOGIN_FAILED ||
                response.result !== resultCodes.RESULT_OK ||
                !responseHelper.isLoggedUserFormatValid(response)
            ) {
                return [
                    messageHelper.getInvalidFormatMessage(response),
                    {
                        type: actionTypes.LOG_OUT_SUCCESS
                    }
                ];
            }

            return [
                {
                    type: actionTypes.CHANGE_USER_SUCCESS,
                    payload: {
                        loggedUser: response.data.user,
                        settingsMenu: modelHelper.mapSettingsMenuToObjects(response.data.user.optionsMenu)
                    }
                }
            ];
        case handlers.GET_ALL_USERS_AND_AUTOLOGIN:
            if (!responseHelper.isGetAllUsersFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            if (!state.login.loggedIn || state.login.loggedUser.autoLogin) {
                return [];
            }

            /*let userList = modelHelper.mapUsersToObjects(response.data);

            for (let user of userList) {
                if (user.autoLogin) {
                    return [
                        {
                            type: actionTypes.SERVER_REQUEST,
                            payload: {
                                type: methods.METHOD_LOG_OUT
                            },
                            method: handlers.LOG_OUT_AND_AUTOLOGIN_USER,
                            tabId: 0,
                            next: {
                                type: actionTypes.SERVER_REQUEST,
                                payload: {
                                    type: methods.METHOD_LOG_IN,
                                    params: {
                                        login: user.login,
                                        password: null
                                    }
                                },
                                method: handlers.LOG_IN_AND_CHANGE_USER,
                                tabId: 0
                            }
                        }
                    ];
                }
            }*/

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_LOG_OUT
                    },
                    method: handlers.LOG_OUT,
                    tabId: 0
                }
            ];
        case handlers.LOG_OUT_AND_AUTOLOGIN_USER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let autologinRequest = state.server.requests.find((request) => request.id === response.sequence);

            if (autologinRequest.next === null) {
                return [
                    {
                        type: actionTypes.LOG_OUT_SUCCESS
                    }
                ];
            }

            return [autologinRequest.next];
        case handlers.GET_ACTIVE_DATABASE_AND_LOG_IN:
            if (!responseHelper.isGetActiveDatabaseFormatValid(response)) {
                return [
                    {
                        type: actionTypes.SAVE_ACTIVE_DATABASE,
                        payload: {
                            database: modelHelper.mapDatabaseToObject(response.data)
                        }
                    },
                    messageHelper.getInvalidFormatMessage(response)
                ];
            }

            if (window.imageStore.dbImageIsEmpty(response.data.name)) {
                return [
                    {
                        type: actionTypes.SAVE_ACTIVE_DATABASE,
                        payload: {
                            database: modelHelper.mapDatabaseToObject(response.data)
                        }
                    },
                    {
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_DATABASE_IMAGE,
                            params: {
                                name: response.data.name
                            }
                        },
                        method: handlers.GET_DATABASE_IMAGE,
                        tabId: 0
                    },
                    {
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_LOGGED_USER
                        },
                        method: handlers.GET_LOGGED_DATABASE_USER,
                        tabId: 0
                    }
                ];
            }

            return [
                {
                    type: actionTypes.SAVE_ACTIVE_DATABASE,
                    payload: {
                        database: modelHelper.mapDatabaseToObject(response.data)
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_LOGGED_USER
                    },
                    method: handlers.GET_LOGGED_DATABASE_USER,
                    tabId: 0
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
